export const grayscaleColor = {
  black: '#000000',
  10: '#101820',
  15: '#231F20',
  20: '#363636',
  40: '#63666A',
  45: '#767676', // Lightest text accessible on a white background
  50: '#808080',
  70: '#BDCCD2',
  72: '#C2CCCC',
  86: '#D9E0E1',
  88: '#D9DFE1',
  90: '#EDF0F0',
  97: '#F7F8F9',
  white: '#ffffff',
};

export const color = {
  thunder: '#231F20', // use grayscaleColor['15']
  bunker: '#101820', // use grayscaleColor['10']
  'mine-shaft': '#363636', // use grayscaleColor['20']
  white: '#ffffff', // use grayscaleColor['white']
  gray: '#EDF0F0', // use grayscaleColor['90']
  tiara: '#C2CCCC', // use grayscaleColor['72']
  porcelain: '#EBF0F0', // use grayscaleColor['90']
  'shuttle-gray': '#63666A', // use grayscaleColor['40']
  'honest-mistake': '#BDCCD2', // use grayscaleColor['70']
  'light-gray': '#F7F8F9', // use grayscaleColor['97']
  'platinum-gray': '#D9E0E1', // use grayscaleColor['86']
  'medium-gray': '#BDCCD2', // use grayscaleColor['70']
  'dark-gray': '#D9DFE1', // use grayscaleColor['88']
  // Blues
  primary: '#007297',
  'medium-blue': '#007297',
  'dark-blue': '#023962',
  // Reds
  'bright-red': '#EC1C23',
  'dark-red': '#8A0203',
  red: '#AB2328',
};

export const fontStackFallback = '"Helvetica Neue", helvetica, arial, sans-serif';

export const fontFamily = {
  sans: `"Gotham", ${fontStackFallback}`,
  Integral: `"Integral", ${fontStackFallback}`,
  FKScreamer: `"FKScreamer", ${fontStackFallback}`,
};

export const fontSize = {
  xxs: '0.625rem', // 10px
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px
  base: '1rem', // 16px
  md: '1.125rem', // 18px
  lg: '1.25rem', // 20px
  xl: '1.5rem', // 24px
  xxl: '2.25rem', // 36px
};

export const fontWeight = {
  bold: 700,
  medium: 500,
  book: 400, // same as `font-weight: normal`
};

export const space = {
  auto: 'auto',
  none: '0',
  xs: '0.25rem', // 4px
  sm: '0.5rem', // 8px
  md: '1rem', // 16px
  lg: '1.5rem', // 24px
  xl: '1.875rem', // 30px
  xxl: '2rem', // 36px
  xxxl: '4rem', // 64px
};
